import React, {Fragment, useEffect, useState} from 'react'
import localization from "../../../../../assets/localization/localization";
import TableSection from "../../../../../components/sales/tableSection/tableSection";
import Layout from "../../../../../components/sales/layout/layout";
import Filter from "../Filter";
import {Button} from "react-bootstrap";
import Images from "../../../../../assets/images/imageData";

const ValetServiceApprovalList = ({
                          getValetItemLineApprovalList,
                          lineItemsApprovalList=[]
                         }) => {
    const [listData, setListData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [showFilter, setShowFilter] = useState(false);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            getValetItemLineApprovalList()
            setIsLoading(false)
        })()
    }, []);

    const headers = [
        "Invoice Id",
        'Invoice Number',
        'Total Price',
        'Actions'
    ];

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    useEffect(() => {
        if (lineItemsApprovalList && lineItemsApprovalList?.data && lineItemsApprovalList?.data.length > 0) {
            const tableData = ['invoice_id', 'invoice_no','price'];
            const data = lineItemsApprovalList?.data.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        {[key]: element[key]}
                    )),
                    {},
                    {Action: [{name: 'View', link: `valet-approval-action-invoice-list/${element['invoice_id']}`}]}
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(lineItemsApprovalList.total / lineItemsApprovalList.per_page));
        }
    }, [lineItemsApprovalList])

    const onPageChange = async (val) => {
        setIsLoading(true);
        await getValetItemLineApprovalList(val.selected + 1, 2);
        setIsLoading(false);
    };

    const applyFilter = async (filterData) => {
        setIsLoading(true);
        localStorage.setItem("valet_invoice_b2b", JSON.stringify(filterData));
        await getValetItemLineApprovalList(1,filterData);
        setIsLoading(false);
        filterToggle();
    };

    const headerBtns = () => {
        return (
            <>
                <Fragment>
                    <Button
                        onClick={filterToggle}
                        className="filter-hamburger btn btn-transparent"
                    >
                        <img src={Images?.Filter} alt=""></img>
                        {localization.showFilters}
                    </Button>
                </Fragment>
            </>
        );
    };

    return (
        <>
            <Layout
                title={localization.approvalList}
                isLoading={isLoading}
                Buttons={headerBtns}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={lineItemsApprovalList && lineItemsApprovalList.data}
                    srNo={lineItemsApprovalList?.from}
                />

                <Filter
                    showFilter={showFilter}
                    filterToggle={filterToggle}
                    applyFilter={(val) => applyFilter(val)}
                />
            </Layout>
        </>
    )
}

export default ValetServiceApprovalList